export default {
  name: 'IEFA LatAm Forum',
  shortName: 'Buenos Aires',
  description:
    'L’IEFA LatAm Forum a tenu sa première édition en 2022. Il s’agit d’une conférence internationale annuelle axée sur le rôle et les opportunités que présente l’Amérique latine dans l’économie mondiale d’aujourd’hui.',
  thumbnail: '/images/events/buenosAires/thumbnail-buenosAires.jpg',
  link: 'https://www.latamforum.com/',
  header: {
    content:
      'L’IEFA LatAm Forum a tenu sa première édition en 2022. Il s’agit d’une conférence internationale annuelle axée sur le rôle et les opportunités que présente l’Amérique latine dans l’économie mondiale d’aujourd’hui.'
  },
  bullets: {
    bullet1: {
      number: '2ème',
      label: 'Édition'
    },
    bullet2: {
      number: '400+',
      label: 'Participants'
    },
    bullet3: {
      number: '30+',
      label: 'Conférenciers'
    },
    bullet4: {
      number: '20+',
      label: 'Pays Représentés'
    }
  },
  about: {
    title: 'Notre objectif',
    content:
      'Cet événement privé, sur invitation uniquement, a été créé comme une plateforme pour discuter du rôle de plus en plus important de l’Amérique latine dans l’économie mondiale d’aujourd’hui. Alors que le monde est à la recherche d’un avenir plus durable et plus résistant, l’IEFA LatAm Forum identifie les organisations est les institutions latino-américaines qui contribuent à la réalisation de cet objectif, à la fois dans la région et dans le monde entier.'
  },
  next: {
    title: '2ème édition',
    content:
      "L'édition 2024 réunira des leaders d'opinion et des décideurs internationaux pour étudier les diverses possibilités qui s'offrent aux Amériques et qui peuvent favoriser la transition mondiale. La conférence, qui se tiendra à l'hôtel Four Seasons de Buenos Aires, en Argentine, comprendra deux jours de panels, de tables rondes, et de réceptions privées, qui offriront aux participants de nombreuses occasions de se rencontrer et d'échanger."
  },
  gallery: {
    title: 'Galerie de photos',
    edition11: {
      title: '11ème édition — Investing in Trust',
      index: [
        {
          image: '/images/events/miami/gallery/12th-miami-001.jpg'
        }
      ]
    }
  }
}
